function initPeopleWatching() {
  const counterSpan = document.querySelector('.product__people-watching-number');

  if (counterSpan) {
    const min = parseInt(counterSpan.getAttribute('data-bstr-cntr-min'), 10) || 5;
    const max = parseInt(counterSpan.getAttribute('data-bstr-cntr-limit'), 10) || 100;

    const intervalAttr = parseInt(counterSpan.getAttribute('data-bstr-cntr-interval'), 10);
    const interval = isNaN(intervalAttr) ? 8000 : intervalAttr * 1000;

    let currentCount = Math.floor(Math.random() * (max - min + 1)) + min;
    counterSpan.textContent = currentCount;

    function updateCounter() {
      const increasing = Math.random() >= 0.5;

      const step = Math.floor(Math.random() * 5) + 1;

      if (increasing) {
        currentCount = Math.min(max, currentCount + step);
      } else {
        currentCount = Math.max(min, currentCount - step);
      }

      counterSpan.textContent = currentCount;
    }

    setInterval(updateCounter, interval);
  }
}

initPeopleWatching();

